export default __webpack_public_path__ + "static/media/problem_2.94344d5f.gif";